import { gql } from '@apollo/client';

export const GET_WATER_SERVICE_IDS = gql`
  query GetWaterServiceIds(
    $where: JSON
    $orderBy: [ColumnOrder]
    $limit: Int
    $offset: Int
    $includeAddress: Boolean = false
  ) {
    waterServices(
      where: $where
      orderBy: $orderBy
      limit: $limit
      offset: $offset
      groupBy: ["id"]
    ) {
      id
      address @include(if: $includeAddress) {
        latitude
        longitude
      }
    }
  }
`;

export const GET_WATER_SERVICES = gql`
  query GetWaterServices(
    $where: JSON
    $orderBy: [ColumnOrder]
    $limit: Int
    $offset: Int
  ) {
    waterServices(
      where: $where
      orderBy: $orderBy
      limit: $limit
      offset: $offset
    ) {
      id
      siteNumber
      meterNumber
      pin
      tags
      recycledWaterSite {
        id
        name
      }
      status
      type
      radioId
      address(required: true) {
        street1
        street2
        city
        state
        zip
        zipExt
      }
    }
  }
`;

export type WaterServiceItem = {
  id: string;
  siteNumber: string;
  meterNumber?: string;
  pin: string;
  tags: string[];
  recycledWaterSite?: {
    id: string;
    name: string;
  };
  status: string;
  type: string;
  radioId: string;
  address: {
    street1: string;
    street2?: string;
    city: string;
    state: string;
    zip: string;
    zipExt?: string;
  };
};
